import { render } from "./CompetitionBracket.vue?vue&type=template&id=629799df&scoped=true"
import script from "./CompetitionBracket.vue?vue&type=script&lang=js"
export * from "./CompetitionBracket.vue?vue&type=script&lang=js"

import "./CompetitionBracket.vue?vue&type=style&index=0&id=629799df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629799df"]])

export default __exports__